<template>
  <div>
    <div>
      <!-- Register v1 -->
      <b-card
        class="mb-0"
        title=""
      >
        <!-- form -->
        <validation-observer
          ref="updatemeetingForm"
          #default="{ invalid }"
        >
          <b-form @submit.prevent>
            <!-- meeting link-->
            <b-col cols="12">
              <b-form-group
                label="Batch"
                label-for="batch"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Batch"
                  vid="batch"
                  rules="required"
                >
                  <v-select
                    id="register-batch"
                    v-model="form.batch"
                    placeholder="Select the Batch"
                    :options="batch"
                    label="label"
                    :reduce="(option) => option.value"
                    :class="{ 'is-invalid': errors.length > 0 }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group
                label="Intake"
                label-for="intake"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Intake"
                  vid="intake"
                  rules="required"
                >
                  <v-select
                    id="register-batch"
                    v-model="form.intake"
                    :options="intake"
                    label="label"
                    :reduce="(option) => option.value"
                    :class="{ 'is-invalid': errors.length > 0 }"
                    placeholder="Select the Intake"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group
                label="Meeting Link"
                label-for="meetingid"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Meeting Id"
                  vid="meeting_id"
                  rules="required"
                >
                  <b-form-input
                    id="register-meetingid"
                    v-model="form.meeting_id"
                    name="register-meetingid"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Enter Meeting Id"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- current month number -->
            <b-col cols="12">
              <b-form-group
                label="Current Month"
                label-for="currentmonth"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Current Month"
                  vid="Current Month"
                >
                  <v-select
                    id="Select Current Month"
                    v-model="form.current_month"
                    :options="months"
                    label="label"
                    :reduce="(option) => option.value"
                    :class="{ 'is-invalid': errors.length > 0 }"
                    placeholder="Select Current Month"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- status -->
            <b-col cols="12">
              <b-form-group
                label="Status"
                label-for="status"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Status"
                  vid="status"
                  rules="required"
                >
                  <v-select
                    id="status"
                    v-model="selected"
                    :options="options"
                    label="label"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- Button -->
            <b-form-group>
              <b-form-input
                id="h-email"
                type="text"
                hidden
              />
            </b-form-group>

            <b-button
              variant="primary"
              block
              type="submit"
              :disabled="invalid"
              @click="updateMeeting()"
            >
              Submit
            </b-button>
          </b-form>
        </validation-observer>
      </b-card>
      <!-- /Register v1 -->
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
import meetingApi from '@/Api/Modules/meetings'
import {
  BCard,
  BLink,
  BCardTitle,
  BCardText,
  BForm,
  BButton,
  BFormInput,
  BFormGroup,
  BInputGroup,
  BImg,
  BInputGroupAppend,
} from 'bootstrap-vue'
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
} from '@validations'

export default {
  name: 'Register',
  components: {
    vSelect,
    BCard,

    BCardTitle,
    BImg,
    BCardText,
    BForm,
    BButton,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,

    // validations
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    meetingdata: Object,
  },
  data() {
    return {
      form: {},
      batch: [
        { label: 'B03', value: 'B03' },
        { label: 'B04', value: 'B04' },
        { label: 'B05', value: 'B05' },
        { label: 'B06', value: 'B06' },
        { label: 'B07', value: 'B07' },
      ],

      intake: [
        { label: '01', value: '01' },
        { label: '02', value: '02' },
      ],
      months: [
        { label: '01', value: 1 },
        { label: '02', value: 2 },
        { label: '03', value: 3 },
        { label: '04', value: 4 },
        { label: '05', value: 5 },
        { label: '06', value: 6 },
      ],
      options: [
        { label: 'Active', value: 1 },
        { label: 'Expired', value: 0 },
      ],
      selected: {},
      // validation rules
      required,
      email,
      confirmed,
      url,
      between,
      alpha,
      integer,
      password,
      min,
      digits,
      alphaDash,
      length,
    }
  },
  created() {
    this.initializeData()
  },
  methods: {
    // initialize data
    initializeData() {
      this.form = this.meetingdata
      this.selected.title = this.meetingdata.link_status
    },
    // update meeting
    async updateMeeting() {
      this.form.link_status = this.selected.value
      if (await this.$refs.updatemeetingForm.validate()) {
        await this.$vs.loading({
          scale: 0.8,
        })
        await meetingApi
          .updateMeeting(this.form, this.meetingdata.id)
          .then(() => {
            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.loading.close()
          })
      }
    },
  },
}
</script>
